import React, {Component, PropTypes} from 'react';
import {FormControl, Checkbox} from '@sketchpixy/rubix';

const REGION_ALL = 'ALL';

class Role extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: this.props.checked,
      countryCode: this.props.countryCode ? this.props.countryCode : REGION_ALL,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      checked: nextProps.checked,
      countryCode: nextProps.countryCode ? nextProps.countryCode : REGION_ALL,
    });
  }

  roleMappedChangeHandler = () => {
    this.setState({
      checked: !this.state.checked,
    }, () => {
      this.props.roleMappedChangeHandler(this.props.role.roleId, this.state.countryCode);
    });
  };

  countryChangeHandler = (event) => {
    this.setState({
      countryCode: event.target.value,
    }, () => {
      this.props.localeChangeHandler(this.props.role.roleId, this.state.countryCode);
    });
  };

  render() {
    return (
        <tr>
          <td>
            <Checkbox checked={this.state.checked} onChange={this.roleMappedChangeHandler} />
          </td>
          <td style={{textAlign: 'left', verticalAlign: 'middle'}}>
            {
              this.props.role.roleName
            }
          </td>
          <td>
            <FormControl
                disabled={!this.state.checked}
                componentClass="select"
                onChange={this.countryChangeHandler}
                value={this.state.countryCode}
                style={{width: '120px'}}>
              <option value={REGION_ALL}>{REGION_ALL}</option>
              {
                this.props.serviceRegions.map(serviceRegion => (
                    <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                      {serviceRegion.countryAlpha3Code}
                    </option>
                ))
              }
            </FormControl>
          </td>
        </tr>
    );
  }
}

Role.propTypes = {
  role: PropTypes.object.isRequired,
  serviceRegions: PropTypes.array,
  regionChangeHandler: PropTypes.func,
  checked: PropTypes.bool,
  countryCode: PropTypes.string,
  roleMappedChangeHandler: PropTypes.func.isRequired,
  localeChangeHandler: PropTypes.func.isRequired,
};

export default Role;



// WEBPACK FOOTER //
// ./src/routes/permission/RoleGroups/RoleGroup/Roles/Role/Role.js